import { render, staticRenderFns } from "./AscDscIcon.vue?vue&type=template&id=816fe508"
import script from "./AscDscIcon.vue?vue&type=script&lang=js"
export * from "./AscDscIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports